import { Component, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { Product } from 'app/models/menu.model';
import * as MenuSelectors from 'app/reducers/menu.selectors';
import { Currency } from 'app/models/currency.model';
import { Store } from '@ngrx/store';

@Component({
  selector: 'app-menu-product-item',
  templateUrl: './product-item.component.html',
  styleUrls: ['./product-item.component.scss']
})
export class ProductItemComponent {

  defaultPicture = 'assets/images/dishes/logo.png';

  @Input() product: Product;

  currency$: Observable<Currency>;

  constructor(
    private store: Store,
  ) {
    this.currency$ = this.store.select(MenuSelectors.selectCurrency);
  }

}
